import FilterSelector from '@/components/FilterSelector.vue';
import { defaultParams, MixerType } from "@/modules/SspDataModule";
import { downloadJson, fileDialog, readFileAsText } from '@/utils/file';
import { Component, Prop, Vue } from "vue-property-decorator";
import { ExternalTileData } from '..';
import SdssTrueColor from "./SdssTrueColor.vue";
import SimpleRgb from "./SimpleRgb.vue";
import { store } from '@/store';

@Component({
  components: {
    SdssTrueColor,
    SimpleRgb,
    FilterSelector,
  },
})
export default class extends Vue {
  @Prop({ required: true })
  t!: ExternalTileData

  get params() {
    return this.t.colorParams
  }

  get filters() {
    return this.t.filters
  }

  save() {
    downloadJson(`hscMap-color-setting.json`, this.params)
  }

  async load() {
    const filelist = await fileDialog()
    if (filelist && filelist.length > 0) {
      const file = filelist.item(0)!
      const params = JSON.parse(await readFileAsText(file))
      this.t.colorParams = params
    }
  }

  reset() {
    this.t.colorParams = defaultParams()
  }

  remove() {
    const entries = store.modules.externalTileData.entries
    entries.splice(entries.indexOf(this.t), 1)
  }

  get mixerTypes() {
    return [
      MixerType.SIMPLE_RGB,
      MixerType.SDSS_TRUE_COLOR,
    ]
  }
}
